
export const API_URLS = {
    //BASE_PATH: "http://localhost:5000",
    //BASE_PATH: "https://dw-proyectofinal-backend-1.onrender.com",
    BASE_PATH: "https://auditoria-api.173.249.47.94.sslip.io",
};

export const ERROR_MESSAGES = {
    CONNECTION_ERROR: "Error connecting to the server",
    INVALID_CREDENTIALS: "Invalid username or password",
};

